<div class="popup product-popup" [ngClass]="show ? 'opened' : ''">
    <div class="container default-container popup-content">
        <div class="popup-header row">
            <h2 class="col h-medium">장바구니 리스트</h2>
            <a href="javascript:;" class="col-auto close-popup-btn" (click)="handleOnClickClosePopup();">
                <svg width="22" height="22" viewBox="0 0 22 22">
                    <path d="M1 1L21 21" />
                    <path d="M21 1L1 21" />
                </svg>
            </a>
        </div>
        <div class="popup-body">
            <!-- <div class="searching-form">
          <div class="container default-container">
            <div class="row form-row">
            </div>
          </div>
        </div> -->

            <!-- Oanh new start design table 8 Aug 2023 -->

            <div class="show-desk">
                <!-- <div>Desk home</div> -->
                <ng-container *ngFor="let item of mapCart | keyvalue; index as i">
                    <div class="container default-container results p-d-0 mg-bt-20" (click)="handleClickChooseCart(item.key)" style="cursor: pointer;">
                        <div class="container p-d-0">
                            <div class="row">
                                <div class=" d-flex tit-order mb-3">
                                    <span class=""><strong>{{+i + 1}}번 장바구니</strong></span>
                                </div>
                                <ng-container *ngFor="let item2 of item.value">
                                    <div class="container d-flex align-items-center mb-3 item-order p-d-0">
                                        <div class="col-md-3 col text-center">
                                            <ng-container *ngIf="item2.filePath === null">
                                                <img class="img-checkout-list" src="./assets/img/noImage.jpg">
                                            </ng-container>
                                            <ng-container *ngIf="item2.filePath !== null">
                                                <img class="img-checkout-list" src="{{ urlWownet + '' + item2.filePath + '' + item2.fileName }}">
                                            </ng-container>
                                        </div>
                                        <div class="col-md-5 col text-left">
                                            {{item2.pdtName}}
                                        </div>
                                        <div class="col-md-1 col text-right">
                                            {{item2.qty}}
                                        </div>

                                        <ng-container *ngIf="item2.cateNameOrg != 'O06'">
                                            <div class="col-md-2 col d-flex">{{(+item2.amt * +item2.qty) | setComma}}원</div>
                                        </ng-container>
                                        <ng-container *ngIf="item2.cateNameOrg == 'O06'">
                                            <div class="col-md-2 col d-flex point">{{(+item2.amt * +item2.qty) | setComma}}<span>P</span></div>
                                        </ng-container>

                                        <div class="col-md-1"></div>
                                    </div>
                                </ng-container>
                            </div>
                            <div class="checkout-price-order d-flex container p-d-0">
                                <div class="col-9 justify-content-end d-flex "><strong>합계</strong></div>

                                <ng-container *ngIf="item.key.countPoint == 0">
                                    <div class="col-2"><strong>{{ item.key.ordAmt | setComma }}원</strong></div>
                                </ng-container>
                                <ng-container *ngIf="item.key.countPoint > 0">
                                    <div class="col-2 point"><strong>{{ item.key.ordAmt | setComma }}<span>P</span></strong></div>
                                </ng-container>

                                <div class="col-1"></div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>

            <div class="show-mobile">
                <div class="container default-container results">
                    <div class="container">
                        <ng-container *ngFor="let item of mapCart | keyvalue; index as i">
                            <div class="row" (click)="handleClickChooseCart(item.key)">
                                <div class=" d-flex tit-order">
                                    <span class=""><strong>{{+i + 1}}번 장바구니</strong></span>
                                </div>
                                <ng-container *ngFor="let item2 of item.value">
                                    <div class="container d-flex align-items-center mt-3 mb-3 item-order">
                                        <div class="mobile-item-detail d-flex w-100 flex-d">
                                            <div class=" col d-flex justify-content-center flex-20-percent">
                                                <ng-container *ngIf="item2.filePath === null">
                                                    <img class="img-checkout-list" src="./assets/img/noImage.jpg">
                                                </ng-container>
                                                <ng-container *ngIf="item2.filePath !== null">
                                                    <img class="img-checkout-list" src="{{ urlWownet + '' + item2.filePath + '' + item2.fileName }}">
                                                </ng-container>
                                            </div>
                                            <div class="col flex-45-percent" style="max-width: 50%;">
                                                {{item2.pdtName}}
                                            </div>
                                            <div class="col flex-10-percent">
                                                {{item2.qty}}
                                            </div>
                                            <div class=" col d-flex flex-25-percent justify-content-start">{{item2.amt | setComma}}원</div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <div class="checkout-price-order d-flex container">
                                <div class="col-9 justify-content-end d-flex "><strong class="p-r-8">합계</strong></div>
                                <div class="col-3"><strong>{{item.key.ordAmt | setComma}}원</strong></div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>

            <!-- Oanh new start design table 8 Aug 2023 -->

            <!-- <div class="container default-container results">
                <div class="table-container">
                    <table class="hr-table list-order-pc">
                        <thead>
                            <tr style="background: #6e1452;">
                                <th style="text-align: center; color: white;">NO</th>
                                <th style="text-align: center; color: white;">장바구니 상품정보</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of mapCart | keyvalue; index as i"
                                (click)="handleClickChooseCart(item.key)">
                                <td style="text-align: center;">{{ +i + 1 }}</td>
                                <td style="text-align: center;">
                                    <div class="border-top head2">
                                        <div class=" d-flex align-items-center">
                                            <div class="col-3">사진</div>
                                            <div class="col-3">상품명</div>
                                            <div class="col-3">수량</div>
                                            <div class="col-3">금액</div>
                                        </div>
                                    </div>
                                    <div class=" mt-1 ">
                                        <ng-container *ngFor="let item2 of item.value">
                                            <div class=" d-flex align-items-center border-bottom border-top">
                                                <div class="col-3">
                                                    <ng-container *ngIf="item2.filePath === null">
                                                        <img src="./assets/img/noImage.jpg"
                                                            style="height: 100px;width: 100px;">
                                                    </ng-container>
                                                    <ng-container *ngIf="item2.filePath !== null">
                                                        <img src="{{ urlWownet + '' + item2.filePath + '' + item2.fileName }}"
                                                            style="height: 100px;width: 100px;">
                                                    </ng-container>
                                                </div>
                                                <div class="col-3">
                                                    <span>
                                                        {{ item2.pdtName }}
                                                    </span>
                                                </div>
                                                <div class="col-3">{{ item2.qty }}</div>
                                                <div class="col-3">{{ item2.amt | setComma }}</div>
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div class=" border-top total-price">
                                        <div class=" d-flex align-items-center">
                                            <div class="col-3 color-pubble"><b>합계</b></div>
                                            <div class="col-3"></div>
                                            <div class="col-3"></div>
                                            <div class="col-3"><b>{{ item.key.ordAmt | setComma }}</b></div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div> -->

            
        </div>
    </div>
</div>